import React from 'react'
import { ElementIcon } from '../ElementIcon'
import { ElementType, SketchElement } from '../../../../../../../inspector'
import * as S from './ElementInfo.styles'
import { ComponentName, SymbolPath } from '../../../components/ComponentName'
import { useDisplayedLayerNameAndOptionalPath } from '../useDisplayedLayerNameAndOptionalPath'
import { isPrivateCloud } from '@sketch/env-config'

type ElementInfoProps = {
  sketchElement: SketchElement
  className?: string
}

export const ElementInfo = ({ sketchElement, className }: ElementInfoProps) => {
  const { displayedName, symbolNamePath } =
    useDisplayedLayerNameAndOptionalPath(sketchElement)

  if (!sketchElement) {
    return null
  }

  /**
   * We want to display as symbol the elements that are symbol instances
   * or the artboards that are symbol masters when the element is an artboard.
   */
  const isSymbol =
    sketchElement.type === ElementType.SymbolMaster ||
    sketchElement.type === ElementType.SymbolInstance

  /**
   * The symbol path dropdown is hidden in private cloud deployments since it
   * does not work for encrypted workspaces.
   * We plan on addressing this issue as part of a wider effort to fix "search"
   * features in encrypted workspaces: SWEB-1367
   */
  const showSymbolPath =
    !isPrivateCloud && symbolNamePath && symbolNamePath.length > 1

  return (
    <S.AttributeContainer className={className}>
      <ElementIcon
        elementType={sketchElement.type}
        // Layers that are exportable gets an extra icon on top of the
        // normal layer type icon.
        hasExports={sketchElement.isExportable}
        isSymbol={isSymbol}
      />
      <S.ComponentName>
        <ComponentName isSymbol={isSymbol}>{displayedName}</ComponentName>
        {showSymbolPath && <SymbolPath paths={symbolNamePath} />}
      </S.ComponentName>
    </S.AttributeContainer>
  )
}
